"use strict";
/**
 *
 * Text
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
// decorate
const decorate_1 = require("./decorate");
const Text = react_1.default.forwardRef(function Text(props, ref) {
    const { children, theme, classes, className, inline, gutterBottom, paragraph, color = 'textPrimary', colorVariant, variant = 'body', weight, font, style, withPlaceholder, wrap, component: PropComponent } = props, rest = __rest(props, ["children", "theme", "classes", "className", "inline", "gutterBottom", "paragraph", "color", "colorVariant", "variant", "weight", "font", "style", "withPlaceholder", "wrap", "component"]);
    const Component = react_1.useMemo(() => {
        if (PropComponent) {
            return PropComponent;
        }
        switch (variant) {
            case 'title':
                return 'h3';
            case 'subtitle':
                return 'h5';
            case 'body':
                return 'p';
            case 'caption':
                return 'span';
            default:
                return 'span';
        }
    }, [PropComponent, variant]);
    function deriveStyle() {
        const manipulator = colorVariant
            ? theme.palette[colorVariant]
            : (color) => theme.palette[color];
        return Object.assign({ color: color === 'inherit' ? 'inherit' : manipulator(color) }, style);
    }
    return (react_1.default.createElement(Component, Object.assign({}, rest, { ref: ref, className: clsx_1.default(classes.root, inline ? classes.inline : classes.block, (gutterBottom || paragraph) && classes.gutterBottom, classes[`variant-${variant}`], weight && classes[`weight-${weight}`], font && classes[`font-${font}`], withPlaceholder && classes.withPlaceholder, wrap && classes.wrap, className), style: deriveStyle() }), children));
});
if (process.env.NODE_ENV !== 'production') {
    Text.displayName = 'Text';
}
const StyledText = decorate_1.decorate(Text);
exports.Text = StyledText;
